exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menu-item[data-v-3bd524b8]:nth-child(2n){background-color:#f2ff00}.menu-item[data-v-3bd524b8]:nth-child(odd){background-color:#f4f9ad}.price[data-v-3bd524b8]{text-align:right}.not-available div[data-v-3bd524b8]{text-decoration:line-through}span.withoutLine[data-v-3bd524b8]{text-decoration:none!important;display:inline-block;padding:0 0 0 5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3bd524b8","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/mittags-tisch/MittagsTisch.vue
// module id = 76
// module chunks = 0